up.compiler('[prompt-link]', (element) => {

  up.on(element, 'click', (event) => {
    event.preventDefault()
    let invoice_number = prompt('Sie können eine Rechnungsnummer für die Rechnung eingeben.')
    window.open(element.getAttribute('href') + `?${element.getAttribute('prompt-link')}=${invoice_number || ''}`, '_blank');
  })

})
